import React, { useEffect, useState } from 'react'
import FooterPages from '../Footer/FooterPages'
import Loader from "react-js-loader";
import UserService from '../../services/UserService';
import { useDispatch } from "react-redux";
import AuthService from '../../services/AuthService';
import getNotification from '../../Redux/Action/action';
import swal from 'sweetalert'
import Chart from "react-apexcharts";
import Navbar2 from '../Navbars/Navbar2';
import SubNavbar from '../Navbars/SubNavbar';
import Navbar3 from '../Navbars/Navbar3';
import { upload } from '@testing-library/user-event/dist/upload';
import axios from 'axios'
import Select, { components } from "react-select";
import ExceptionVariables from '../JSON Files/ExceptionVariables.json'
import LoaderCustom from '../LoaderCustom';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
const XLSX = require("xlsx");


const { REACT_APP_REDIRECT_URI } = process.env;
const { REACT_APP_UPLOAD_DATA } = process.env;

function RefreshModel() {
  const [modifybtn,setmodifybtn]=useState(false)
  const [mapetable, setmapetable] = useState( []);
  const fileTypes = ["XLS", "XLSX", "CSV", "TSV"];
  const [brandoptions, setbrandoptions] = useState([ ]);
  const [selectedbrand, setselectedbrand] = useState("");
  const [timetorefresh, settimetorefresh] = useState(9000);
  const [percentagetoshowonloader, setpercentagetoshowonloader] = useState(0);
const [loaderpull,setloaderpull]=useState(false)
const [loaderrefresh,setloaderrefresh]=useState(false)
 //const [timetorefreshinterval,settimetorefreshinterval]=useState(0)
  const [displaynames, setdisplaynames] = useState({});
  const [resultscreen, setresultscreen] = useState(false);
  const [resultscreen3, setresultscreen3] = useState(false);
  const [loader1, setloader1] = useState(false);
  const [loader, setloader] = useState(false);
  const [loader2, setloader2] = useState(false);
  const [fileupload, setfileupload] = useState("")
  const [uploadfile, setuploadfile] = useState("")
  const [uploadfiledata, setuploadfiledata] = useState([])
  const [uploadfilefilterobject, setuploadfilefilterobject] = useState({ Brand: "Select", FY: "Select", Final_Market: "Select" })
  const [summaryfilterobject, setsummaryfilterobject] = useState({ Brand: "Select", FY: "Select", Final_Market: "Select" })
  const [resultscreen4, setresultscreen4] = useState(false)
  const [resultscreen2, setresultscreen2] = useState(true)
  const [newscenarionamegiven, setnewscenarionamegiven] = useState("");
  const [plotdata, setplotdata] = useState([]);
const [maxdatebeforerefresh,setmaxdatebeforerefresh]=useState("")
const [newrecordstable,setnewrecordstable]=useState([])
  let counter = 1;

  const [modelperformanceplotdata, setmodelperformanceplotdata] = useState({
    "actual_sales": [
      {
        "month_year": "2021-04",
        "year": "2021",
        "month": "04",
        "brand": "Harrier",
        "scenario_name": "Base Scenario",
        "f_year": "2021-22",
        "model_id": 1,
        "sales": 1470.0
      },
      {
        "month_year": "2021-05",
        "year": "2021",
        "month": "05",
        "brand": "Harrier",
        "scenario_name": "Base Scenario",
        "f_year": "2021-22",
        "model_id": 1,
        "sales": 889.0
      },
      {
        "month_year": "2021-06",
        "year": "2021",
        "month": "06",
        "brand": "Harrier",
        "scenario_name": "Base Scenario",
        "f_year": "2021-22",
        "model_id": 1,
        "sales": 2084.0
      },
      {
        "month_year": "2021-07",
        "year": "2021",
        "month": "07",
        "brand": "Harrier",
        "scenario_name": "Base Scenario",
        "f_year": "2021-22",
        "model_id": 1,
        "sales": 2543.0
      },
      {
        "month_year": "2021-08",
        "year": "2021",
        "month": "08",
        "brand": "Harrier",
        "scenario_name": "Base Scenario",
        "f_year": "2021-22",
        "model_id": 1,
        "sales": 2659.0
      },
      {
        "month_year": "2021-09",
        "year": "2021",
        "month": "09",
        "brand": "Harrier",
        "scenario_name": "Base Scenario",
        "f_year": "2021-22",
        "model_id": 1,
        "sales": 2483.0
      },
      {
        "month_year": "2021-10",
        "year": "2021",
        "month": "10",
        "brand": "Harrier",
        "scenario_name": "Base Scenario",
        "f_year": "2021-22",
        "model_id": 1,
        "sales": 3655.0
      },
      {
        "month_year": "2021-11",
        "year": "2021",
        "month": "11",
        "brand": "Harrier",
        "scenario_name": "Base Scenario",
        "f_year": "2021-22",
        "model_id": 1,
        "sales": 2216.0
      },
      {
        "month_year": "2021-12",
        "year": "2021",
        "month": "12",
        "brand": "Harrier",
        "scenario_name": "Base Scenario",
        "f_year": "2021-22",
        "model_id": 1,
        "sales": 3198.0
      },
      {
        "month_year": "2022-01",
        "year": "2022",
        "month": "01",
        "brand": "Harrier",
        "scenario_name": "Base Scenario",
        "f_year": "2021-22",
        "model_id": 1,
        "sales": 2361.0
      },
      {
        "month_year": "2022-02",
        "year": "2022",
        "month": "02",
        "brand": "Harrier",
        "scenario_name": "Base Scenario",
        "f_year": "2021-22",
        "model_id": 1,
        "sales": 2239.0
      },
      {
        "month_year": "2022-03",
        "year": "2022",
        "month": "03",
        "brand": "Harrier",
        "scenario_name": "Base Scenario",
        "f_year": "2021-22",
        "model_id": 1,
        "sales": 2661.0
      }
    ],
    "predictions": [
      {
        "scenario_name": "scenario_0909",
        "f_year": "2021-22",
        "created_dt": "2024-09-09T15:26:43",
        "week_year": "2021-04",
        "weekly_predicted_sales": 2629.2261259876,
        "temp_month_year": 1617235200000,
        "financial_year": 2021
      },
      {
        "scenario_name": "scenario_0909",
        "f_year": "2021-22",
        "created_dt": "2024-09-09T15:26:43",
        "week_year": "2021-05",
        "weekly_predicted_sales": 765.5225672414,
        "temp_month_year": 1619827200000,
        "financial_year": 2021
      },
      {
        "scenario_name": "scenario_0909",
        "f_year": "2021-22",
        "created_dt": "2024-09-09T15:26:43",
        "week_year": "2021-06",
        "weekly_predicted_sales": 1754.3702375492,
        "temp_month_year": 1622505600000,
        "financial_year": 2021
      },
      {
        "scenario_name": "scenario_0909",
        "f_year": "2021-22",
        "created_dt": "2024-09-09T15:26:43",
        "week_year": "2021-07",
        "weekly_predicted_sales": 2110.5942683931,
        "temp_month_year": 1625097600000,
        "financial_year": 2021
      },
      {
        "scenario_name": "scenario_0909",
        "f_year": "2021-22",
        "created_dt": "2024-09-09T15:26:43",
        "week_year": "2021-08",
        "weekly_predicted_sales": 2765.7224618237,
        "temp_month_year": 1627776000000,
        "financial_year": 2021
      },
      {
        "scenario_name": "scenario_0909",
        "f_year": "2021-22",
        "created_dt": "2024-09-09T15:26:43",
        "week_year": "2021-09",
        "weekly_predicted_sales": 2438.3735914273,
        "temp_month_year": 1630454400000,
        "financial_year": 2021
      },
      {
        "scenario_name": "scenario_0909",
        "f_year": "2021-22",
        "created_dt": "2024-09-09T15:26:43",
        "week_year": "2021-10",
        "weekly_predicted_sales": 2886.2376084099,
        "temp_month_year": 1633046400000,
        "financial_year": 2021
      },
      {
        "scenario_name": "scenario_0909",
        "f_year": "2021-22",
        "created_dt": "2024-09-09T15:26:43",
        "week_year": "2021-11",
        "weekly_predicted_sales": 2034.2668355296,
        "temp_month_year": 1635724800000,
        "financial_year": 2021
      },
      {
        "scenario_name": "scenario_0909",
        "f_year": "2021-22",
        "created_dt": "2024-09-09T15:26:43",
        "week_year": "2021-12",
        "weekly_predicted_sales": 2983.6576513895,
        "temp_month_year": 1638316800000,
        "financial_year": 2021
      },
      {
        "scenario_name": "scenario_0909",
        "f_year": "2021-22",
        "created_dt": "2024-09-09T15:26:43",
        "week_year": "2022-01",
        "weekly_predicted_sales": 2625.0137168552,
        "temp_month_year": 1640995200000,
        "financial_year": 2021
      },
      {
        "scenario_name": "scenario_0909",
        "f_year": "2021-22",
        "created_dt": "2024-09-09T15:26:43",
        "week_year": "2022-02",
        "weekly_predicted_sales": 2383.0941637195,
        "temp_month_year": 1643673600000,
        "financial_year": 2021
      },
      {
        "scenario_name": "scenario_0909",
        "f_year": "2021-22",
        "created_dt": "2024-09-09T15:26:43",
        "week_year": "2022-03",
        "weekly_predicted_sales": 1638.9092782476,
        "temp_month_year": 1646092800000,
        "financial_year": 2021
      }
    ]
  })
  const [salesdata, setsalesdata] = useState([])
  const [options, setoptions] = useState({})
  const dispatch = useDispatch();

  useEffect(() => {

    handlevariablesfetchfybrand()
    //handlevariablesfetch();
  }, []);
  const handlevariablesfetchfybrand = async () => {
    if (UserService.isLoggedIn()) {
      try {
        const FormData = require("form-data");
        const sendData = new FormData();

        const config = {
          method: "get",
          url: `${REACT_APP_UPLOAD_DATA}/app/get_brand_fy`,
          headers: {
            Accept: "text/plain",
            "Content-Type": "application/json",
          },
          data: sendData,
        };
        const getResponse = await axios(config);

        if (getResponse.data !== "Invalid User!") {


          // setbrandoptions(
          // ExceptionVariables?.brandoptions?.map((it)=>{
          // return {label:it.brand,value:it.brand}
          //            }))

          // setmarketoptions(
          //   getResponse.data.markets
          // );
          setbrandoptions(
            getResponse.data.brands?.filter(it => !ExceptionVariables?.brandoptionshide2?.includes(it?.brand))?.sort((a,b)=>a.brand.localeCompare(b.brand))?.map((it) => {
              return { value: it.brand, label: it.brand };
            })
          );

        }
      } catch (err) {
        console.log("Server Error", err);
        if (err.response && err.response.status === 500) {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 400) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 422) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 404) {
          dispatch(
            getNotification({
              message: "Page not Found",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 401) {
          dispatch(
            getNotification({
              message: "Session expired! Please log in again",
              type: "default",
            })
          );
        } else {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        }
      }
    } else {
      setTimeout(() => {
        UserService.doLogin({
          redirectUri: `${REACT_APP_REDIRECT_URI}/modelperformance`,
        });
      }, 1000);
    }
  };
  const downloadSampleFile = async () => {

    const fileUrl = `Assets/Files/SampleFile.xlsx`;
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', 'sampleFile.xlsx'); 
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); 
  }

    const handleUploadfile = async () => {
      if (uploadfile) {
          setloader(true);
          if (UserService.isLoggedIn()) {
              setresultscreen3(false);
              setresultscreen4(false);
              const reader = new FileReader();
              reader.readAsBinaryString(uploadfile);
              reader.onload = (e) => {
                  const data = e.target.result;
                  const workbook = XLSX.read(data, { type: "binary" });
                  const sheetName = workbook.SheetNames[0];
                  const sheet = workbook.Sheets[sheetName];
                  const parsedData = XLSX.utils.sheet_to_json(sheet, { raw: false });

                  // Convert date fields if necessary
                  const formattedData = parsedData.map(row => {
                      return Object.fromEntries(
                          Object.entries(row).map(([key, value]) => {
                              // Check if the value is a date (could be a number)
                              if (typeof value === 'number' && !isNaN(value)) {
                                  // Convert Excel serial date to JavaScript Date
                                  const date = XLSX.SSF.parse_date_code(value);
                                  return [key, new Date(date.y, date.m - 1, date.d)];
                              }
                              return [key, value];
                          })
                      );
                  });

                  setuploadfiledata(formattedData);
                  console.log(formattedData);
              };
              setresultscreen(true);
              setTimeout(() => {
                  setresultscreen(true);
                  setloader(false);
              }, 4000);
          } else {
              setTimeout(() => {
                  UserService.doLogin({
                      redirectUri: `${REACT_APP_REDIRECT_URI}/refreshmodel`,
                  });
              }, 1000);
          }
      } else {
          dispatch(
              getNotification({
                  message: "Please attach excel file to upload!",
                  type: "Default",
              })
          );
      }
  };

  // const handleUploadfile = async () => {
  //   if (UserService.isLoggedIn()) {
  //     if (uploadfile) {
  //       try {
  //         setloader1(true)
  //         const FormData = require("form-data");
  //         const sendData = new FormData();
         
  //         sendData.append("file", uploadfile);

  //         const config = {
  //           method: "post",
  //           url: `${REACT_APP_UPLOAD_DATA}/app/upload-excel`,
  //           headers: {
  //             Accept: "application/json",

  //           },
  //           data: sendData,
  //         };
  //         const getResponse = await axios(config);
  //         console.log(getResponse);
  //         if (getResponse.status === 200) {
  //           if (getResponse?.data?.data.length > 0) {
  //             setresultscreen(true)
  //             setuploadfiledata(getResponse.data.data);
  //           }
  //         }
  //       } catch (err) {
  //         console.log("Server Error", err);
  //         if (err.response && err.response.status === 500) {
  //           dispatch(
  //             getNotification({
  //               message: "Server is Down! Please try again after sometime",
  //               type: "default",
  //             })
  //           );
  //         } else if (err.response && err.response.status === 400) {
  //           dispatch(
  //             getNotification({
  //               message: "Input is not in prescribed format",
  //               type: "default",
  //             })
  //           );
  //         } else if (err.response && err.response.status === 422) {
  //           dispatch(
  //             getNotification({
  //               message: "Input is not in prescribed format",
  //               type: "default",
  //             })
  //           );
  //         } else if (err.response && err.response.status === 404) {
  //           dispatch(
  //             getNotification({
  //               message: "Page not Found",
  //               type: "default",
  //             })
  //           );
  //         } else if (err.response && err.response.status === 401) {
  //           dispatch(
  //             getNotification({
  //               message: "Session expired! Please log in again",
  //               type: "default",
  //             })
  //           );
  //         } else {
  //           dispatch(
  //             getNotification({
  //               message: "Server is Down! Please try again after sometime",
  //               type: "default",
  //             })
  //           );
  //         }
  //       }
  //     }
  //     else {
  //       dispatch(
  //         getNotification({
  //           message: "Please attach file",
  //           type: "default",
  //         })
  //       );
  //     }
  //   } else {
  //     setTimeout(() => {
  //       UserService.doLogin({
  //         redirectUri: `${REACT_APP_REDIRECT_URI}/refreshmodel`,
  //       });
  //     }, 1000);
  //   }
  //   setloader1(false)
  // };
  const handlefetchmaxdatebeforerefresh= async (brand) => {
    if (UserService.isLoggedIn()) {
      try{
     
        if(true){
          try {
            setmaxdatebeforerefresh("")
            let config = {};
        
            const requestData = {
            brand: brand,
           
            };
              config = {
              method: "post",
              url: `${REACT_APP_UPLOAD_DATA}/app/model_Min_date_before_refresh`,
              headers: {
                Accept: "text/plain",
                "Content-Type": "application/json",
               
              },
              data: requestData,
            };
    
          const getResponse = await axios(config);
     // console.log(getResponse)
          if (getResponse.status===200) {
            setmaxdatebeforerefresh(getResponse?.data[0]?.max_date_before_refresh?.split("T")[0]?.split("-")?.reverse()?.join("-"))
       
                setresultscreen2(true)
             setdisplaynames({
              ...displaynames,
              brand: selectedbrand,
           
              
            })
       
          
          }
        } catch (err) {
          console.log("Server Error", err);
       
          if (err.response && err.response.status === 500) {
            dispatch(
              getNotification({
                message: "Server is Down! Please try again after sometime",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 400) {
            dispatch(
              getNotification({
                message: "Input is not in prescribed format",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 422) {
            dispatch(
              getNotification({
                message: "Input is not in prescribed format",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 404) {
            dispatch(
              getNotification({
                message: "Page not Found",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 401) {
            dispatch(
              getNotification({
                message: "Session expired! Please log in again",
                type: "default",
              })
            ); setTimeout(UserService.doLogin(), 1000)
          } else {
            dispatch(
              getNotification({
                message: "Server is Down! Please try again after sometime",
                type: "default",
              })
            );
          }
        }}
         else{
          dispatch(
            getNotification({
              message: "Please fill all entries",
              type: "danger",
            })
          );
         }
        
      }
      catch(err){
        console.log("Server Error", err);
        if (err.response && err.response.status === 500) {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 400) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 422) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 404) {
          dispatch(
            getNotification({
              message: "Page not Found",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 401) {
          dispatch(
            getNotification({
              message: "Session expired! Please log in again",
              type: "default",
            })
          );
        } else {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        }
      }
      } else {
        setTimeout(() => {
          UserService.doLogin({
            redirectUri: `${REACT_APP_REDIRECT_URI}/refreshmodel`,
          });
        }, 1000);
      }

  }
  const handlepulllatestdata = async () => {
    if (UserService.isLoggedIn()) {
      try{
        if(selectedbrand===""){
          dispatch(getNotification({
            message:"Please select brand!",
            type:"danger"
          }))
          return
        }
        
       

 

     setnewrecordstable([])
        if(true){
          try {
            setloader(true)
            setloaderpull(true)
          let config = {};
        
            const requestData = {
            brand:selectedbrand,
        
    
            };
              config = {
              method: "post",
              url: `${REACT_APP_UPLOAD_DATA}/app/model_refresh_pull`,
              headers: {
                Accept: "text/plain",
                "Content-Type": "application/json",
               
              },
              data: requestData,
            };
    
          const getResponse = await axios(config);
 
        //setProgressInterval(interval);
    // console.log(getResponse)
          if (getResponse.status===200) {
      
        setpercentagetoshowonloader(0)

           if(getResponse.data===null){
              dispatch(
                getNotification({
                  message: "There are no records to upload!",
                  type: "default",
                })
              );
            }
            else{
              setnewrecordstable(getResponse?.data[4])
             setresultscreen(true)
             setdisplaynames({
              ...displaynames,
              brand: selectedbrand,
           
              
            })
       
            }
          }
        
        } catch (err) {
          
          console.log("Server Error", err);
                 if (err.response && err.response.status === 500) {
            dispatch(
              getNotification({
                message: "Server is Down! Please try again after sometime",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 400) {
            dispatch(
              getNotification({
                message: "Input is not in prescribed format",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 422) {
            dispatch(
              getNotification({
                message: "Input is not in prescribed format",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 404) {
            dispatch(
              getNotification({
                message: "Page not Found",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 401) {
            dispatch(
              getNotification({
                message: "Session expired! Please log in again",
                type: "default",
              })
            ); setTimeout(UserService.doLogin(), 1000)
          } else {
            dispatch(
              getNotification({
                message: "Server is Down! Please try again after sometime",
                type: "default",
              })
            );
          }
        }}
         else{
          dispatch(
            getNotification({
              message: "Please fill all entries",
              type: "danger",
            })
          );
         }
         setloader(false)
      
      }
      catch(err){
        console.log("Server Error", err);
        if (err.response && err.response.status === 500) {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 400) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 422) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 404) {
          dispatch(
            getNotification({
              message: "Page not Found",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 401) {
          dispatch(
            getNotification({
              message: "Session expired! Please log in again",
              type: "default",
            })
          );
        } else {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        }
      }
      } else {
        setTimeout(() => {
          UserService.doLogin({
            redirectUri: `${REACT_APP_REDIRECT_URI}/refreshmodel`,
          });
        }, 1000);
      }
      setloader(false)
      setloaderpull(false)
  }
  const handlerefreshmodel = async () => {
    if (UserService.isLoggedIn()) {
      try{
     
     setnewrecordstable([])
        if(true){
          try {
            setloader(true)
            setloaderrefresh(true)
          let config = {};
        
            const requestData = {
            brand:selectedbrand,
        
    
            };
              config = {
              method: "post",
              url: `${REACT_APP_UPLOAD_DATA}/app/model_refresh_save`,
              headers: {
                Accept: "text/plain",
                "Content-Type": "application/json",
               
              },
              data: requestData,
            };

            let timetorefreshinterval=0
            let percentage=0
            let interval=setInterval(() => {
              if(percentage<100){
               //settimetorefreshinterval(timetorefreshinterval+30)
              percentage+=1
              setpercentagetoshowonloader(percentage)
               timetorefreshinterval+=30
               console.log(timetorefreshinterval)
              }
              else{
               clearInterval()
              // setpercentagetoshowonloader(100)
              }
             }, timetorefresh);
          const getResponse = []

     // console.log(getResponse)
          if (getResponse.status===200) {
            clearInterval(interval)
            setmaxdatebeforerefresh(getResponse?.data[1][0]?.max_date?.split("T")[0]?.split("-")?.reverse()?.join("-"))
            swal('Data uploaded successfully!',
              `Data Available from: ${getResponse?.data[0][0]?.min_date?.split("T")[0]?.split("-")?.reverse()?.join("-")} 
              Till ${getResponse?.data[1][0]?.max_date?.split("T")[0]?.split("-")?.reverse()?.join("-")}
              New Records Inserted: ${getResponse?.data[3][0]?.new_records}
              `
              , 'success');
             // console.log(Array.from(new Set(getResponse?.data[4].map(it=>it.attribute_name))).length,Array.from(new Set(getResponse?.data[4].map(it=>it.final_market))))
//setnewrecordstable(getResponse?.data[4])
             setresultscreen2(true)
             setdisplaynames({
              ...displaynames,
              brand: selectedbrand,
           
              
            })
       
          
          }
        } catch (err) {
          console.log("Server Error", err);
          if(displaynames){
            setselectedbrand(displaynames.brand || brandoptions[0].brand)
              
            // setselectedscenarioid(displaynames.id || modelcallibrationoptions[1].id)
          }
          if (err.response && err.response.status === 500) {
            dispatch(
              getNotification({
                message: "Server is Down! Please try again after sometime",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 400) {
            dispatch(
              getNotification({
                message: "Input is not in prescribed format",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 422) {
            dispatch(
              getNotification({
                message: "Input is not in prescribed format",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 404) {
            dispatch(
              getNotification({
                message: "Page not Found",
                type: "default",
              })
            );
          } else if (err.response && err.response.status === 401) {
            dispatch(
              getNotification({
                message: "Session expired! Please log in again",
                type: "default",
              })
            ); setTimeout(UserService.doLogin(), 1000)
          } else {
            dispatch(
              getNotification({
                message: "Server is Down! Please try again after sometime",
                type: "default",
              })
            );
          }
        }}
         else{
          dispatch(
            getNotification({
              message: "Please fill all entries",
              type: "danger",
            })
          );
         }
         setloader(false)
         setloaderrefresh(false)
      }
      catch(err){
        console.log("Server Error", err);
        if (err.response && err.response.status === 500) {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 400) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 422) {
          dispatch(
            getNotification({
              message: "Input is not in prescribed format",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 404) {
          dispatch(
            getNotification({
              message: "Page not Found",
              type: "default",
            })
          );
        } else if (err.response && err.response.status === 401) {
          dispatch(
            getNotification({
              message: "Session expired! Please log in again",
              type: "default",
            })
          );
        } else {
          dispatch(
            getNotification({
              message: "Server is Down! Please try again after sometime",
              type: "default",
            })
          );
        }
      }
      } else {
        setTimeout(() => {
          UserService.doLogin({
            redirectUri: `${REACT_APP_REDIRECT_URI}/refreshmodel`,
          });
        }, 1000);
      }

  }
  const handlesavemodelcallibration=()=>{

  }
  const fetchmodelperformanceplot = () => {
    setloader(true)
    document.getElementById("closemodal").click()
    setTimeout(() => {

      setresultscreen4(true)
      setresultscreen3(false)
      setloader(false)
      // setresultscreen2(false)
      setsalesdata([{ name: "Actual Sales", data: modelperformanceplotdata.actual_sales.map((it) => it.sales.toFixed(0)) },
      { name: "Predicted Sales", data: modelperformanceplotdata.predictions.map((it) => it.weekly_predicted_sales.toFixed(0)) }
      ])
      setoptions(
        {
          chart: {
            id: `Download`,
            type: "line",



            toolbar: {
              show: true,
            },
          },
          stroke: {
            width: 2 // Change this value to reduce the line width
          },
          grid: {
            show: false, // Keep grid enabled

          },
          title: {
            text: 'Actual vs Predicted',
            align: 'center',
          },
          plotOptions: {

          },
          colors: ['#4CAF50', '#FFC107'],
          dataLabels: {
            enabled: true,
            style: {
              fontSize: '8px !important',

            },
            formatter: function (val) {
              return val
            }
          },

          xaxis: {
            categories: modelperformanceplotdata.actual_sales.map((it) => it.month_year),
            title: {
              text: 'Months',
              style: {
                color: "#FFC107",
              },
            },
            labels: {
              style: {
                fontSize: "10px !important",

              },
              formatter: function (val) {
                return val
              }
            },
          },
          yaxis: [
            {
              seriesName: 'Sales',
              opposite: false,
              axisBorder: {
                show: true // Ensures Y-axis line is visible
              },
              title: {
                text: "Sales",
                showAlways: true,
                floating: true,
                style: {
                  color: "#4CAF50",
                },

              },
              labels: {
                style: {
                  fontSize: '10px',

                }
              }
            },
            ,
            // {
            //   seriesName: 'Predicted Sales',
            //   opposite: true,
            //   title: {
            //     text: "Predicted Sales",
            //     showAlways: true,
            //     floating: true, 
            //      style:{
            //     color:"#FFC107"
            //   },

            //   },


            // },
          ],

        });
    }, 3000);
  }
  return (
    <>
      <div
        class="modal" 
        id="exampleModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog"  role="document">
          <div className="modal-content" style={{width:"400px",height:"250px"}}>
            <div class="modal-header" style={{ backgroundColor: "#f2f2f2" }}>
              <h6 class="modal-title" id="exampleModalLabel">
                Save Model Callibration
              </h6>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                id="closemodal"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body ">

             <div className='card'>
             <label>Please enter Model Callibration Name:</label>
              <input
                type="text"
                id="scenarionamebox"
                className="form-control"
                value={newscenarionamegiven}
                onChange={(e) => {handlesavemodelcallibration();setnewscenarionamegiven(e.target.value)}}
              />
             </div>

              <br />
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary btn-sm"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                onClick={() => {
                  if (newscenarionamegiven === "" || newscenarionamegiven === "Base Scenario") {
                    document.getElementById("scenarionamebox").focus();
                  } else {
                    fetchmodelperformanceplot() 

                  }
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
      <Navbar3 />
      <SubNavbar />
      <div className="bgpages">
        <div className=' container-fluid py-3 mx-2'>
          <div className='greentheme '>{`Dashboard >> Refresh Model`}</div>
          <div className='p-2 bg-white greentheme my-3' style={{ fontSize: "20px" }}><b>Refresh Model</b></div>
          <div>
            {loader2 ? (
              <div
                className="row d-flex  justify-content-center align-items-center "
                style={{ height: "83vh" }}
              >
                <Loader
                  type="box-rectangular"
                  bgColor={"#0A4742"}
                  title={"Processing Plots..."}
                  color={"#0A4742"}
                  size={75}
                />
              </div>
            ) :
              resultscreen2 &&
          
              <div>
                <div className='card p-3'>
                <div className="row ">
                    <div className="col-sm">
                      <div className="">Brand<span className="text-danger">*</span></div>
                      <div className="" >
                      <Select
  placeholder="Select Brand"
  value={selectedbrand ? { label: selectedbrand, value: selectedbrand } : null}
  className="my-2 w-75"
  options={brandoptions}
  onChange={(value) => {
    handlefetchmaxdatebeforerefresh(value.value);
    setselectedbrand(value.value);
    setnewrecordstable([]);
    setresultscreen(false);
    setmodifybtn(false);
  }}
  styles={{
    menuPortal: (base) => ({ ...base, zIndex: 9999 }) // High z-index ensures it appears above everything
  }}
  menuPortalTarget={document.body} // Moves dropdown to body
/>


                      </div>
                    </div>
                    <div className='col-sm d-flex'>
                    
                    {/* <div class="submitfrmtbtn mx-2 " type="button"  onClick={() => {
                    // fetchdatasettable()
                    handlepulllatestdata()
                  }}><span>Pull Latest data <iconify-icon icon="iconamoon:arrow-right-2-bold"></iconify-icon></span>
                  </div> */}
                  
                 {resultscreen  && <div class="submitfrmtbtnred mx-2" type="button"  onClick={() => {
                    // fetchdatasettable()
                    handlerefreshmodel()
                  }}><span>Save <iconify-icon icon="iconamoon:arrow-right-2-bold"></iconify-icon></span>
                  </div>
                 }
                 
                  
                      </div>
                    </div>
                    {maxdatebeforerefresh && <div >
                      Data Available for {selectedbrand} till:<span className='text-danger'> {maxdatebeforerefresh}</span>
                      </div>}
                  </div>
             
                  {loader ?
                  <div
                  className="row d-flex  justify-content-center align-items-center "
                  style={{ height: "60vh" }}
                >
         {loaderrefresh && <div    style={{ height: "25vh",width:"25vh" }}>
                  <CircularProgressbar value={percentagetoshowonloader} maxValue={100} text={`${percentagetoshowonloader}%`} />
                  </div>}         
                 {loaderpull && <LoaderCustom text={"Data Pull is happening..."}/>}
                </div> : <div className=''>

                 

                      {loader1 ? <div>
                        Loading...</div> :
                        resultscreen4 &&
                        (
                          <>

                          <div className='card p-3'>
                            Data Availability in DB: 
                            {Array.from(new Set(uploadfiledata?.map((item) => {
                                      return item?.FY
                                    }))).map((it) => {
                                      return <div>{it}</div>
                                    })}
                          <div className='row mt-3'>
                              <span className='col-sm'>
                                <label class=" ">Financial Year</label>
                                <div>
                                  <select className=' border w-50 p-2' onChange={(e) => setuploadfilefilterobject({ ...uploadfilefilterobject, FY: e.target.value })}>
                                    <option>Select</option>
                                     {Array.from(new Set(uploadfiledata.map((item) => {
                                      return item.FY
                                    }))).map((it) => {
                                      return <option>{it}</option>
                                    })}

                                  </select>
                                </div>
                              </span>
                              <span className='col-sm'> <label className='' >Brand</label><div>
                                <select className=' border w-50 p-2' onChange={(e) => setuploadfilefilterobject({ ...uploadfilefilterobject, Brand: e.target.value })}>
                                  <option>Select</option>
                                  {Array.from(new Set(uploadfiledata.map((item) => {
                                    return item.Brand
                                  }))).map((it) => {
                                    return <option>{it}</option>
                                  })}
                                </select>
                              </div></span>
                              <span className='col-sm'><label className=''> Market</label><div>
                                <select className=' border w-50 p-2' onChange={(e) => setuploadfilefilterobject({ ...uploadfilefilterobject, Final_Market: e.target.value })}>
                                  <option>Select</option>
                                  {Array.from(new Set(uploadfiledata.map((item) => {
                                    return item.Final_Market
                                  }))).map((it) => {
                                    return <option>{it}</option>
                                  })}
                                </select></div> </span>
                            </div>

                            <div className="tablescrollbar my-5" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                              <table className="table text-center">
                                <thead  style={{ position: 'sticky', top: 0, zIndex: 1 }}>

                                  <tr className="" >
                                    <th scope="col bg-secondary ">#</th>
                                    {Object.keys(uploadfiledata[0])?.map((item) => {
                                      return (
                                        <th
                                          scope="col"
                                          style={(item === "Brand" || item === "FY") ? { minWidth: "125px",backgroundColor:"#f2f2f2" } : {backgroundColor:"#f2f2f2"}}
                                        >
                                          {item}
                                        </th>
                                      );
                                    })}
                                  </tr>
                                </thead>
                                <tbody className=''>


                                  {uploadfiledata?.map((row, index) => (
                                    (!uploadfilefilterobject ||
                                      (
                                        (uploadfilefilterobject.Brand === "Select" || row.Brand === uploadfilefilterobject.Brand) &&
                                        (uploadfilefilterobject.FY === "Select" || row.FY === uploadfilefilterobject.FY) &&
                                        (uploadfilefilterobject.Final_Market === "Select" || row.Final_Market === uploadfilefilterobject.Final_Market)
                                      )) &&
                                    <tr key={index}>
                                      <td>{counter++}</td>

                                      {
                                        Object.values(row).map((value, index) => (
                                          <td key={index}>
                                            {(!isNaN(Number(value)) && isFinite(Number(value))) ? Number(value).toFixed(0) : value}</td>
                                        ))}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                          </>)
                      }
                      {resultscreen3 && <div className='card p-1 '>
                      <table className='text-center table table-sm my-4 table-striped shadow table-bordered table-responsive-md col-sm-10 mx-auto' style={{ fontSize: "12px" }}>
                          <thead className='' style={{}}>
                            <th>S. No.</th>
                            <th>Brand</th>
                            <th>Market</th>
                            <th> R<sup>2</sup></th>
                            <th>MAPE</th>
                            <th>Select</th>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1</td>
                              <td>YIPPEE NOODLES</td>
                              <td>APTG</td>
                              <td>0.67</td>
                              <td style={{ backgroundColor: "#a9d08e" }}>14%</td>
                              <td><input type="checkbox" checked /></td>
                            </tr>
                            <tr>
                              <td>2</td>
                              <td>YIPPEE NOODLES</td>
                              <td>DL</td>
                              <td>0.10</td>
                              <td style={{ backgroundColor: "#ff0000" }}>31%</td>
                              <td><input type="checkbox" /></td>
                            </tr>
                            <tr>
                              <td>3</td>
                              <td>YIPPEE NOODLES</td>
                              <td>GJ</td>
                              <td>0.45</td>
                              <td style={{ backgroundColor: "#e2efda" }}>20%</td>
                              <td><input type="checkbox" checked /></td>
                            </tr>
                            <tr>
                              <td>4</td>
                              <td>YIPPEE NOODLES</td>
                              <td>HR</td>
                              <td>0.27</td>
                              <td style={{ backgroundColor: "#ff0000" }}>51%</td>
                              <td><input type="checkbox" /></td>
                            </tr>
                            <tr>
                              <td>5</td>
                              <td>YIPPEE NOODLES</td>
                              <td>KA</td>
                              <td>0.51</td>
                              <td style={{ backgroundColor: "#a9d08e" }}>14%</td>
                              <td><input type="checkbox" checked /></td>
                            </tr>
                            <tr>
                              <td>6</td>
                              <td>YIPPEE NOODLES</td>
                              <td>KL</td>
                              <td>0.65</td>
                              <td style={{ backgroundColor: "#548235" }}>9%</td>
                              <td><input type="checkbox" checked /></td>
                            </tr>
                            <tr>
                              <td>7</td>
                              <td>YIPPEE NOODLES</td>
                              <td>MH</td>
                              <td>0.60</td>
                              <td style={{ backgroundColor: "#a9d08e" }}>12%</td>
                              <td><input type="checkbox" checked /></td>
                            </tr>
                            <tr>
                              <td>8</td>
                              <td>YIPPEE NOODLES</td>
                              <td>MPCH</td>
                              <td>0.47</td>
                              <td style={{ backgroundColor: "#548235" }}>9%</td>
                              <td><input type="checkbox" checked /></td>
                            </tr>

                          </tbody>
                        </table>
                        <div>
                          *R<sup>2</sup> :Coefficient of Determination,
                          * MAPE: Mean Absolute Percentage Error
                        </div>
                        </div>}
                      {resultscreen4 &&

                        <div>
                          <div className='d-flex flex-row-reverse' onClick={() => {
                            setresultscreen3(true);
                            setresultscreen4(false);
                          }}><button className='btnlightgreen mt-3'>Back to Refresh Model</button> </div>
                          Model Callibration Name: {newscenarionamegiven}
                          <div className='card my-4 p-4'>
                          <div className='row mt-3'>
                              <span className='col-sm'>
                                <label class=" ">Financial Year</label>
                                <div>
                                  <select className=' border w-50 p-2' onChange={(e) => setsummaryfilterobject({ ...summaryfilterobject, FY: e.target.value })}>
                                    <option>Select</option> {Array.from(new Set(uploadfiledata.map((item) => {
                                      return item.FY
                                    }))).map((it) => {
                                      return <option>{it}</option>
                                    })}

                                  </select>
                                </div>
                              </span>
                              <span className='col-sm'> <label className='' >Brand</label><div>
                                <select className=' border w-50 p-2' onChange={(e) => setsummaryfilterobject({ ...summaryfilterobject, Brand: e.target.value })}>
                                  <option>Select</option>
                                  {Array.from(new Set(uploadfiledata.map((item) => {
                                    return item.Brand
                                  }))).map((it) => {
                                    return <option>{it}</option>
                                  })}
                                </select>
                              </div></span>
                              <span className='col-sm'><label className=''> Market</label><div>
                                <select className=' border w-50 p-2' onChange={(e) => setsummaryfilterobject({ ...summaryfilterobject, Final_Market: e.target.value })}>
                                  <option>Select</option>
                                  {Array.from(new Set(uploadfiledata.map((item) => {
                                    return item.Final_Market
                                  }))).map((it) => {
                                    return <option>{it}</option>
                                  })}
                                </select></div> </span>
                            </div>
                            {mapetable?.length>0 && 
 <table className="text-center table table-sm my-4 table-striped shadow table-bordered table-responsive-md col-sm-10 mx-auto" style={{ fontSize: "12px" }}>
 <thead>
   <tr>
     <th>S. No.</th>
     <th>Brand</th>
     <th>Market</th>
     <th>MAPE</th>
     <th>Select for More details</th>
   </tr>
 </thead>
 <tbody>
   {mapetable.map((row,index) => (
    <>
     <tr key={index+1}>
       <td>{index+1}</td>
       <td>{row.brand}</td>
       <td>{row.market}</td>
       <td style={{color:"white", backgroundColor: row.mape<0.20?"green":"red" }}>{row.mape}</td>
       <td>
         <input type="checkbox" data-toggle="collapse" data-target={`#chart${index}`} role="button" aria-expanded="false" aria-controls={`chart${index}`} 
        
          />
       </td>
        
     </tr>
<tr className="mx-auto ">
<td colSpan="5" className=""> 
<div class="collapse multi-collapse p-4" id={`chart${index}`} >
<Chart

align="center"
options={options[index]}
series={plotdata[index]}
height={400}
width={'90%'}
/> 

      
      
    </div>
    </td>
</tr> </>
   ))}
   
 </tbody>
 
</table>
                        }
                          </div>
                        

                        </div>}

                    </div>}


                  {/* <div className="col-sm-5 my-auto">
           <img src="../Assets/Images/image1.png" className="mr-1" align="right" style={{width:"500px"}} />
         </div> */}

              
                {newrecordstable?.length>0 &&  <div className='my-3'>
                  <div className='my-2'>
         <b>     <div>  New Records: </div></b>
    <div>     Total Row count {newrecordstable?.length}</div>
     <div>     Total column count {Object.keys(newrecordstable[0])?.length}</div>
    
                  </div>
                  <div  style={{height:"690px",overflowX:"scroll",overflowY:"scroll",position: "relative"}}>
                  
               
  <table className="table table-sm table-bordered table-responsive-xl table-responsive-md table-responsive-sm table-responsive-lg">
    <thead  style={{ position: "sticky", top: 0, background: "white", zIndex: 100 }}>
      <tr  >
        <th className="text-white bg-secondary">#</th>
        {Object.keys(newrecordstable[0])?.map((keys, index) => (
          <th className="text-white bg-secondary" key={index}>{keys}</th>
        ))}
      </tr>
    </thead>
    <tbody>

                      {newrecordstable?.map((values, index) => (
  <tr key={index}>
    <td>{index + 1}</td>
    {Object.keys(values).map((key, keyIndex) => (
      <td key={keyIndex}>{values[key]}</td>
    ))}
  </tr>
))}
  
                    
                
                        </tbody>
                        </table></div></div>}
                 </div>}
          </div>
    </div></div>
      
      
      <FooterPages />
    </>

  )
}

export default RefreshModel